import { ANCAPLogo } from './ancap-logo';
import { RedbookLogo } from './redbook-logo';
import { TACLogo } from './tac-logo';
import { UCSRLogo } from './ucsr-logo';
import { UCSRCombinedLogo } from './ucsr-combined-logo';
import { VicLogo } from './vic-logo';

export { ANCAPLogo, RedbookLogo, TACLogo, UCSRLogo, UCSRCombinedLogo, VicLogo };
